<template>
    <ValidationObserver tag="form" ref="paso2" @submit.prevent="submit()">
        <b-row>
            <b-col cols="12" class="d-md-flex justify-content-between align-items-center mb-3 mb-md-0">
                <TitleComponent title="2. Tus abonos" subtitle="- Completa la información necesaria para cada uno de los abonos seleccionados" />
                <Button :disabled="disabled" @click="cambiarButacas">Cambiar abonos</Button>
            </b-col>
            <b-col cols="12 mb-4">
                <div class="custom-control custom-checkbox">
                    <input class="custom-control-input" type="checkbox" v-model="select_all" id="select_all" :disabled="disabled"/>
                    <label class="custom-control-label pt-1" for="select_all">Seleccionar todos los abonos</label>
                </div>
            </b-col>
            <b-col cols="12">
                <b-row id="datos-abonos">
                    <template v-for="(abono, index) in datos_de_compradores">
                        <b-col lg="4" md="6" sm="12" :key="index">
                            <DatosAbonoComponent
                                :key="loading"
                                :index="index"
                                :abono="abono"
                                :generos="generos"
                                :precios="precios"
                                :area="abono.area"
                                :desactivar="disabled"
                                :validator="$refs.observer"
                                @borrar="borrar(index)"
                                @actualizado="actualizar(index)"
                                @isValidNumber="validarTelefono"
                            />
                        </b-col>
                    </template>
                </b-row>
            </b-col>
            <template v-if="tienenPrecio">
                <b-col cols="12">
                    <Button id="continuar-paso3" type="submit" class="btn-block" :disabled="disabled">
                        CONTINUAR COMPRA
                    </Button>
                </b-col>
            </template>
        </b-row>
    </ValidationObserver>
</template>

<script>
    import TitleComponent from '@/components/backend/stepper/components/TitleComponent';
    import DatosAbonoComponent from '@/components/backend/stepper/components/DatosAbonoComponent';

    export default {
        props: {
            datos_compradores: {
                type: Array,
                required: true
            },
            precios: {
                type: Array,
                required: true
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                loading: 999,
                select_all: false,
                isValidNumber: []
            }
        },
        methods: {
            async submit() {
                const isValid = await this.$refs.paso2.validate();
                const allPhonesValid = this.isValidNumber.every(valid => valid);

                if(isValid && allPhonesValid) {
                    this.$emit('terminado', this.datos_de_compradores);
                } else {
                    this.$nextTick(function() {
                        this.$scrollTo('.is-invalid');
                    });
                }
            },
            actualizar(index) {
                if(this.select_all && index == 0) {
                    for(var i in this.datos_de_compradores) {
                        var datos = Object.assign({}, this.datos_de_compradores[index]);

                        if (this.datos_de_compradores[i].id !== undefined) {
                            datos.id = this.datos_de_compradores[i].id;
                        }

                        if (this.datos_de_compradores[i].area !== undefined) {
                            datos.area = this.datos_de_compradores[i].area;
                        }

                        this.$set(this.datos_de_compradores, i, datos);
                        this.loading = i;
                    }
                } else {
                    var datos2 = Object.assign({}, this.datos_de_compradores[index]);

                    if (this.datos_de_compradores[index].id !== undefined) {
                        datos2.id = this.datos_de_compradores[index].id;
                    }

                    if (this.datos_de_compradores[index].area !== undefined) {
                        datos2.area = this.datos_de_compradores[index].area;
                    }

                    this.$set(this.datos_de_compradores, index, datos2);
                    this.loading = index;
                }

                this.loading = 999;

                this.$emit('actualizar', this.datos_de_compradores);
            },
            borrar(index) {
                this.$emit('borrado', index);
            },
            cambiarButacas() {
                this.$emit('cambiarButacas', 1, true)
            },
            validarTelefono({ index, valid }) {
                this.$set(this.isValidNumber, index, valid);
            }
        },
        computed: {
            tienenPrecio() {
                let precio = true;

                Object.values(this.datos_de_compradores).forEach(abono => {
                    if(abono.precio == undefined) {
                        precio = false;
                    }
                })

                return precio;
            },
            datos_de_compradores() {
                return this.datos_compradores;
            },
            generos() {
                return this.$store.getters.getGeneros;
            }
        },
        components: {
            TitleComponent, DatosAbonoComponent
        }
    }
</script>